import React from 'react';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';
import { MagneticButton } from '../components/animated/MagneticButton';
export function ContactPage() {
  const handleCalendlyClick = () => {
    window.open('https://calendly.com/precious-ajoonu', '_blank');
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-687">
      <main className="flex-grow pt-32" data-id="element-688">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-white py-16" data-id="element-689">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-690">
            <div className="max-w-4xl mx-auto text-center" data-id="element-691">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-692">
                We'd Love to Hear From You
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-693">
                Whether you have questions about our consulting services, need
                help upskilling your team, or just want to learn more about
                SkillzHQ, our team is here to assist you.
              </p>
              <MagneticButton variant="primary" size="lg" onClick={handleCalendlyClick} data-id="element-694">
                Book a Discovery Call
              </MagneticButton>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16 bg-white" data-id="element-695">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-696">
            <div className="max-w-4xl mx-auto" data-id="element-697">
              <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-698">
                Get in Touch
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-699">
                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-700">
                  <div className="flex items-center mb-4" data-id="element-701">
                    <Mail className="h-6 w-6 text-blue-600 mr-3" data-id="element-702" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-703">Email</h3>
                  </div>
                  <a href="mailto:support@skillzhq.com" className="text-blue-600 hover:text-blue-700" data-id="element-704">
                    support@skillzhq.com
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-705">
                  <div className="flex items-center mb-4" data-id="element-706">
                    <Phone className="h-6 w-6 text-blue-600 mr-3" data-id="element-707" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-708">Phone</h3>
                  </div>
                  <a href="tel:+2348106836707" className="text-blue-600 hover:text-blue-700" data-id="element-709">
                    0810 683 6707
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-710">
                  <div className="flex items-center mb-4" data-id="element-711">
                    <Clock className="h-6 w-6 text-blue-600 mr-3" data-id="element-712" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-713">
                      Office Hours
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-714">
                    Monday - Friday
                    <br data-id="element-715" />
                    8:00 AM - 5:00 PM
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-716">
                  <div className="flex items-center mb-4" data-id="element-717">
                    <MapPin className="h-6 w-6 text-blue-600 mr-3" data-id="element-718" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-719">Address</h3>
                  </div>
                  <p className="text-gray-700" data-id="element-720">
                    SkillzHQ Headquarters
                    <br data-id="element-721" />
                    Jeydens Court, Agungi, Lagos
                  </p>
                </div>
              </div>

              {/* CTA Section */}
              <div className="bg-gradient-to-br from-blue-600 to-green-600 p-8 rounded-2xl text-center" data-id="element-722">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-723">
                  Ready to Transform Your Organization?
                </h3>
                <p className="text-blue-100 mb-6" data-id="element-724">
                  Schedule a 30-minute discovery call with our team to discuss
                  your needs and explore how we can help.
                </p>
                <MagneticButton variant="secondary" size="lg" onClick={handleCalendlyClick} data-id="element-725">
                  Book a Discovery Call
                </MagneticButton>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>;
}